import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    content: 'text-sm fw-light'
  }
} satisfies RecursivePartial<VfConfig['accordion']>
